import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GroupsPage } from './groups';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    GroupsPage,
  ],
  imports: [
    IonicPageModule.forChild(GroupsPage),
    DirectivesModule
  ],
})
export class GroupsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/groups/groups.module.ts